import { render, staticRenderFns } from "./pcmBseg.vue?vue&type=template&id=70f0dcc4&scoped=true"
import script from "./pcmBseg.vue?vue&type=script&lang=js"
export * from "./pcmBseg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f0dcc4",
  null
  
)

export default component.exports